import React, { FC } from "react";
import { useController, useFormContext } from "react-hook-form";
import { RadioGroup, RadioGroupItem } from "src/components/ui/radio-group";

interface Props {
	stepNumber: number;
	stepAnswers: BannerRadioAnswer[];
}

const RadioStep: FC<Props> = ({ stepNumber, stepAnswers }) => {
	const { control } = useFormContext<BannerFormState>();

	const rules = { required: "Please enter an answer" };

	const { field } = useController({
		name: `steps.${stepNumber - 1}.value`,
		control,
		rules
	});

	return (
		<RadioGroup
			aria-label={`step-answers-${stepNumber}`}
			id={`step-${stepNumber}`}
			className="flex flex-row gap-6 mt-6"
			value={field.value}
			onValueChange={field.onChange}
		>
			{stepAnswers.map(({ name }) => (
				<div
					key={name}
					className={[
						"flex items-center gap-2",
						field.value === name ? "text-zinc-800" : "text-zinc-600"
					].join(" ")}
				>
					<RadioGroupItem value={name} id={`step-${stepNumber}-${name}`} />
					<label
						htmlFor={`step-${stepNumber}-${name}`}
						className="text-sm cursor-pointer flex-1"
					>
						{name} promotion banner
					</label>
				</div>
			))}
		</RadioGroup>
	);
};

export default RadioStep;
